import * as React from 'react';
import { CoreAutocomplete } from '../internal/WixUiCoreComponents/components/CoreAutocomplete';
import { ChevronDown } from '@wix/wix-ui-icons-common';
import { st, classes } from './Autocomplete.deprecated.st.css';
import { ErrorMessageWrapper } from '../ErrorMessageWrapper';
export const Autocomplete = ((props) => {
    const { errorMessage, error, suffix, className, theme, ...coreAutocompleteProps } = props;
    const { disabled } = props;
    return (React.createElement(ErrorMessageWrapper, { error: error, errorMessage: errorMessage, disabled: disabled, render: (errorProps) => (React.createElement(CoreAutocomplete, { className: st(classes.root, { error, theme }, className), ...coreAutocompleteProps, error: errorProps.error, "data-hook": props['data-hook'], suffix: React.createElement("span", { className: classes.suffix },
                React.createElement(ChevronDown, { width: 14, height: 14, viewBox: "8 7 9 10", className: classes.arrowIcon }),
                suffix) })) }));
});
Autocomplete.createOption = CoreAutocomplete.createOption;
Autocomplete.createDivider = CoreAutocomplete.createDivider;
//# sourceMappingURL=Autocomplete.js.map